/**
 * LEGACY / DEPRECATED (Pic2Content Core 1.0, Phase 0.5 — Generation 1:
 * Workspace → Item → Asset → ProcessingVersion). Reachable only by direct
 * URL (/assets) — not linked from AppLayout's nav. Not deleted, not
 * restyled. Do not build new product features on this page; the current
 * product surface is Home.tsx (AssetChain). See
 * docs/architecture/PIC2CONTENT_CORE_1_0.md.
 */
import { useEffect, useState } from 'react'
import { Button, Input, Select, Space, Table, Tag, message } from 'antd'
import { useNavigate } from 'react-router-dom'
import { batchExport, batchProcess, listCategories, listItems } from '../api/client'
import { useDefaultWorkspace } from '../hooks/useDefaultWorkspace'
import type { Item, LabelValue } from '../types'
import { statusColor } from '../utils/status'

export default function ItemsPage() {
  const workspaceId = useDefaultWorkspace()
  const [items, setItems] = useState<Item[]>([])
  const [categories, setCategories] = useState<LabelValue[]>([])
  const [selected, setSelected] = useState<string[]>([])
  const [q, setQ] = useState('')
  const [category, setCategory] = useState<string | undefined>()
  const [status, setStatus] = useState<string | undefined>()
  const navigate = useNavigate()

  const load = async () => {
    if (!workspaceId) return
    const [{ data: cats }, { data: list }] = await Promise.all([
      listCategories(),
      listItems(workspaceId, {
        ...(q ? { q } : {}),
        ...(category ? { category } : {}),
        ...(status ? { status } : {}),
      }),
    ])
    setCategories(cats)
    setItems(list)
  }

  useEffect(() => {
    load().catch((e) => message.error(e.message))
  }, [workspaceId, q, category, status])

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <div>
          <h2 style={{ margin: 0 }}>白底资产</h2>
          <div style={{ color: '#8c8c8c' }}>已生成或正在生成白底图的物品</div>
        </div>
        <Space>
          <Button
            disabled={!selected.length}
            onClick={async () => {
              await batchProcess({ item_ids: selected })
              message.success('批量抠图已排队')
            }}
          >
            批量自动抠图
          </Button>
          <Button
            disabled={!selected.length}
            onClick={async () => {
              await batchExport({ item_ids: selected, make_zip: true })
              message.success('批量导出已排队')
            }}
          >
            批量导出
          </Button>
        </Space>
      </div>

      <Space style={{ marginBottom: 12 }} wrap>
        <Input.Search placeholder="搜索编号/名称" allowClear onSearch={setQ} style={{ width: 220 }} />
        <Select
          allowClear
          placeholder="分类"
          style={{ width: 160 }}
          options={categories.map((c) => ({ value: c.value, label: c.label }))}
          onChange={setCategory}
        />
        <Select
          allowClear
          placeholder="状态"
          style={{ width: 160 }}
          options={[
            { value: 'imported', label: '已导入' },
            { value: 'processing', label: '处理中' },
            { value: 'waiting_for_review', label: '待审核' },
            { value: 'completed', label: '已完成' },
            { value: 'failed', label: '失败' },
            { value: 'partial', label: '部分完成' },
          ]}
          onChange={setStatus}
        />
      </Space>

      <Table
        rowKey="id"
        dataSource={items}
        rowSelection={{ selectedRowKeys: selected, onChange: (k) => setSelected(k as string[]) }}
        onRow={(r) => ({ onDoubleClick: () => navigate(`/assets/${r.id}`) })}
        columns={[
          {
            title: '封面',
            width: 72,
            render: (_, r) =>
              r.cover_thumbnail_url ? (
                <img src={r.cover_thumbnail_url} alt="" width={48} height={48} style={{ objectFit: 'cover' }} />
              ) : (
                '-'
              ),
          },
          { title: '编号', dataIndex: 'item_code' },
          { title: '名称', dataIndex: 'display_name' },
          { title: '分类', dataIndex: 'category_label' },
          { title: '原图', dataIndex: 'asset_count', width: 70 },
          { title: '已处理', dataIndex: 'processed_count', width: 80 },
          { title: '待审核', dataIndex: 'waiting_review_count', width: 80 },
          {
            title: '状态',
            dataIndex: 'status',
            render: (s: string, r) => <Tag color={statusColor[s]}>{r.status_label || s}</Tag>,
          },
          {
            title: '更新',
            dataIndex: 'updated_at',
            render: (v: string) => (v ? new Date(v).toLocaleString() : '-'),
          },
          {
            title: '操作',
            width: 100,
            render: (_, r) => (
              <Button type="link" onClick={() => navigate(`/assets/${r.id}`)}>
                详情
              </Button>
            ),
          },
        ]}
      />
    </div>
  )
}
